import React from 'react';

/**
 * Collapsible section with header and list.
 * Header is title-only — row markers live on items (avoids duplicate,
 * misaligned icons in the section chrome).
 */
export const MissionsSection = ({
  title,
  count,
  isCollapsed,
  onToggle,
  isActive = false,
  variant,
  children,
}) => {
  const sectionVariant = variant ?? (isActive ? 'active' : 'available');

  return (
    <div
      className={[
        'flowchart-hud__missions',
        `flowchart-hud__missions--${sectionVariant}`,
        isCollapsed && 'flowchart-hud__missions--collapsed',
      ].filter(Boolean).join(' ')}
    >
      <button
        type="button"
        className="flowchart-hud__missions-header"
        onClick={onToggle}
      >
        <span className="flowchart-hud__missions-header-text">
          <span className="flowchart-hud__missions-title">{title}</span>
          <span className="flowchart-hud__missions-count">{count}</span>
        </span>
        <svg
          className={`flowchart-hud__missions-chevron ${isCollapsed ? '' : 'flowchart-hud__missions-chevron--open'}`}
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          aria-hidden
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div
        className={`flowchart-hud__missions-list ${isCollapsed ? 'flowchart-hud__missions-list--collapsed' : ''}`}
      >
        <div className="flowchart-hud__missions-list-inner">
          {children}
        </div>
      </div>
    </div>
  );
};
